module.exports = __webpack_public_path__ + "2b8ba2ab29c07a2531c592579d8b2e4e.pdf";